<script lang="ts">
    import Image from '$lib/components/_DisplayComponents/Image/Image.svelte';
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    // Utils
    import clsx from 'clsx';
    import { getWidthByScreenSize } from '$lib/components/_DisplayComponents/_utils/getWidthByScreenSize';
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    // Types
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { ImageContent } from '$lib/types/Components/Image/ImageContent';

    export let content: ImageContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;

    const borderRadius = getBorderRadius('image');
    const isFramedOrInFramedColumn = content.framed || layout.isInFramedColumn;
</script>

<svelte:component
    this={Image}
    src={content.src}
    framed={content.framed}
    size={content.size}
    bgColor={content.box.backgroundColor}
    fixedMaxWidth={getWidthByScreenSize()}
    borderRadiusClass={clsx(borderRadius, {
        'max-sm:rounded-none': !isFramedOrInFramedColumn,
    })}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
